import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'lockton-apps-divider-type',
    template: `<mat-divider class="d-block mb-2"></mat-divider>`,
    standalone: false
})
export class DividerTypeComponent extends FieldType {}
